import Form from "@/components/Shared/Form";
import { Container, Row, Col } from "reactstrap";
import styles from "./styles.module.scss";

export const ColumnWithForm = ({
  className,
  title,
  content,
  form,
  successPageUrl,
  backgroundColor,
  heading,
}) => {
  if (!form) {
    return null;
  }

  return (
    <section
      id="form"
      className={`${styles.root} ${className} ${
        backgroundColor === "white" ? "bg-white" : "bg-black"
      }`}
    >
      <Container className="position-relative py-3 py-md-4">
        <Row>
          <Col
            md={6}
            className={`pe-md-5 mb-4 mb-md-0 ${
              backgroundColor === "white" ? "text-black" : "text-white"
            }`}
          >
            {title && <h2 className={`${heading} mb-4 fw-bold`}>{title}</h2>}
            {content && <div dangerouslySetInnerHTML={{ __html: content }} />}
          </Col>
          <Col md={6} className="ps-md-5">
            <div
              className={`p-5 rounded-4 formWrapper ${
                backgroundColor === "white"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              <Form
                formId={form}
                onSubmitDone={() =>
                  (window.location.href = `${successPageUrl}`)
                }
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ColumnWithForm;
